import apiService from "./apiServices"; 

export const policyTransactionHistoryService = async (id, page, size, token) => {
    try {
        const response = await apiService(`/transactions/policy/${id}?page=${page}&size=${size}`, 'GET', null, null, token);
        return response;
    } catch (error) {
        throw (error?.message || 'Policy Transactions History failed. Please try again.');
    }
};